export default function AJAX_XMLHttp() {
  return (
    <div>
      <h1>AJAX_XMLHttp</h1>
      <p>This is the AJAX_XMLHttp component.</p>
    </div>
  );
}